import {checkSectionVisibility} from '../Common/checkSectionVisibility';
import {initializeVideoCarousel} from '../Common/videoCarousel';

export let slidesCount = 0;
export function populateVideoCarousel(jsonData){

    videoData = jsonData;

    var videoHeadingText = jsonData.videoCarousel.section_heading.value;

    if(!$(document).find(".preview").hasClass("hidden")){
        $("#videoHeadingText").html(videoHeadingText);    
    }
    else{          
        checkSectionVisibility(jsonData.videoCarousel.visibility, $(".video"));                  
        $("input#videoHeadingText").val(videoHeadingText);    
    }

    function getVideos() {
        var video = $('.video__slide.prototype.hidden').clone().removeClass('prototype hidden');
        video.addClass("video");
        return {
            element: video,
            name: video.find('.thumbnail_image'),
            link: video.find(".play"),
            thumbnail: video.find('.thumbnail_image'),
            descriptionHeading: video.find('.video__title').find(".title"),
            descriptionText: video.find('.video__description').find(".description")
        }
    }

    // var count = 0
    function populateData(jsonData){
        // $('.video__carousel-container').slick('slickAdd', $('.video__slide.prototype.hidden'));

        $.each(jsonData.videoCarousel.data.videos, function(index, item) {
            // $.each(item, function(i, Item) {
                if(slidesCount<jsonData.videoCarousel.data.maximum){                    
                    var newVideo = getVideos();
                    // console.log(index, i);
                    if(!$(document).find(".preview").hasClass("hidden")){
                        newVideo.descriptionHeading.html(item.descriptionHeading.value);
                    }
                    else{                            
                        newVideo.descriptionHeading.val(item.descriptionHeading.value);
                    }
                    newVideo.name.attr('name',item.name);
                    newVideo.thumbnail.attr('src',item.thumbnail.value);
                    newVideo.thumbnail.attr('data-src',item.thumbnail.value);

                    if(item.thumbnail.value.indexOf('_cropped')> -1){
                        newVideo.thumbnail.attr('data-original-src',item.thumbnail.value.split('_cropped')[0] + '.jpg');
                    }
                    else{
                        newVideo.thumbnail.attr('data-original-src',item.thumbnail.value);  
                    }
                    
                    newVideo.link.attr('data',item.link);
                    newVideo.descriptionHeading.val(item.descriptionHeading.value);
                    newVideo.descriptionText.html(item.descriptionText.value);

                    if(slidesCount>=jsonData.videoCarousel.data.minimum){
                        $('.video__carousel-container>.video__slide:nth-child(2)').css('margin-left', '15px');
                        if(!($('.video__carousel-container').hasClass("slick-initialized"))){
                            initializeVideoCarousel();
                        }            
                        newVideo.element.addClass("carouselElement");
                        newVideo.element.find(".removeVideo").removeClass("hidden");
                        $('.video__carousel-container').slick('slickAdd', newVideo.element);
                        $('.video__carousel-container>.slick-cloned').remove(); 
                    }
                    else{
                        if($(window).width()< 768){
                            if(!($('.video__carousel-container').hasClass("slick-initialized"))){
                                initializeVideoCarousel();
                            }
                            newVideo.element.addClass("carouselElement");
                            $('.video__carousel-container').slick('slickAdd', newVideo.element);
                            $('.video__carousel-container>.slick-cloned').remove();
                        }
                        else{
                            newVideo.element.css("display", "inline-block");
                            $('.video__carousel-container').append(newVideo.element);
                            $('.video__carousel-container>.video__slide:nth-child(2)').css('margin-left','30px');
                        }       
                    }
                    slidesCount++;   
                }
                // console.log("after pops", slidesCount);

            // });
        });

        // $('.video__slide').last().remove();

        // var slideCount = $(".video__carousel-container").slick("getSlick").slideCount;
        // var lastSlideCount = slideCount - 1;                

        // if($(window).width() > 610){
            // 
        // }
        // else{
        //     $("[data-slick-index =" +  slideCount + "]").remove();
        // }

        // $('.video__slide.prototype.hidden').removeClass('hidden');
        // $('.slick-slide').first().remove();

    }

    function addDynamicVideoSlide(){
        var newVideo = getVideos();
        newVideo.link.attr("src", pageUrl+"/static/images/play.svg");
        newVideo.thumbnail.attr("src", pageUrl+"/static/images/video_1.jpg");
        newVideo.element.find(".removeVideo").removeClass("hidden");
        newVideo.element.addClass("carouselElement");
        $('.video__carousel-container>.video__slide:nth-child(2)').css('margin-left', '15px');

        if(slidesCount<=2 && !($('.video__carousel-container').hasClass("slick-initialized"))){
            initializeVideoCarousel();        
        }
        $('.video__carousel-container').slick('slickAdd', newVideo.element);
        $('.video__carousel-container').find('button.slick-next').click();
        newVideo.element.css("background-color", "#cbe4ff");
        window.setTimeout(function(){
            newVideo.element.css("background-color", "#fff"); 
        }, 1000);
        
    }

    $(".addVideo").on('click', function(){        
        if(slidesCount<jsonData.videoCarousel.data.maximum){
            addDynamicVideoSlide();
            slidesCount++   
            // console.log("after add", slidesCount);         
        }
        else{
            toastNotify(3,"You have acheived the maximum limit.");
        }
    });   

    $(".video__carousel-container").on('click', ".removeVideo" ,function(){          
        $(this).parent().remove();
        $(".video__carousel-container").find('.slick-arrow').remove();
        $(".video__carousel-container").slick('reinit');
        slidesCount--;     
        // console.log("after remove", slidesCount);
        if(slidesCount<=2){
            $('.video__carousel-container').slick('unslick');
            $('.video__carousel-container').find(".carouselElement").remove()
            $('.video__carousel-container>.video__slide:nth-child(2)').css('margin-left', '30px');
            $(".video__carousel-container").find('.slick-arrow').remove();
        }   
    });

    populateData(jsonData);
}